export default __webpack_public_path__ + "static/media/bg3.bc934d63.png";